import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';

const emojiFreeRegex = /^[\w\s.,'!&@()-]+$/;

const phoneDigitsTest = (value: any) => {
  if (value && String(value).trim().length > 0) {
    return yup
      .string()
      .min(7, VALIDATION_MESSAGE.PHONE_NUMBER_VALID)
      .max(15, VALIDATION_MESSAGE.PHONE_MAX_CHAR)
      .matches(/^[0-9]*$/, VALIDATION_MESSAGE.VALID_PHONE_NUMBER)
      .test('valid-phone', VALIDATION_MESSAGE.VALID_PHONE, (v: any) => {
        if (/^0+$/.test(v)) return false;
        return true;
      })
      .isValidSync(value);
  }
  return true;
};

const RegisterValidation: any = yup.object().shape({
  account_type: yup
    .string()
    .oneOf(['individual', 'business'], 'Please select account type')
    .required(VALIDATION_MESSAGE.Field('account type')),

  first_name: yup.string().when('account_type', {
    is: 'individual',
    then: (schema: any) =>
      schema
        .required(VALIDATION_MESSAGE.Field('first name'))
        .min(2, VALIDATION_MESSAGE?.MinLength('First name', 2))
        .max(50, VALIDATION_MESSAGE?.MaxLength('First name', 50))
        .matches(emojiFreeRegex, 'Emojis not allowed'),
    otherwise: (schema: any) => schema.notRequired().nullable(),
  }),

  last_name: yup.string().when('account_type', {
    is: 'individual',
    then: (schema: any) =>
      schema
        .required(VALIDATION_MESSAGE.Field('last name'))
        .min(2, VALIDATION_MESSAGE?.MinLength('Last name', 2))
        .max(50, VALIDATION_MESSAGE?.MaxLength('Last name', 50))
        .matches(emojiFreeRegex, 'Emojis not allowed'),
    otherwise: (schema: any) => schema.notRequired().nullable(),
  }),

  company_name: yup.string().when('account_type', {
    is: 'business',
    then: (schema: any) =>
      schema
        .required(VALIDATION_MESSAGE.Field('company name'))
        .min(2, VALIDATION_MESSAGE?.MinLength('Company name', 2))
        .max(120, VALIDATION_MESSAGE?.MaxLength('Company name', 120))
        .matches(emojiFreeRegex, 'Emojis not allowed'),
    otherwise: (schema: any) => schema.notRequired().nullable().transform(() => undefined),
  }),

  email: yup
    .string()
    .required(VALIDATION_MESSAGE.Field('email'))
    .email(VALIDATION_MESSAGE.EMAIL_ADDRESS)
    .matches(VALIDATION_MESSAGE.EMAIL_REGREX, VALIDATION_MESSAGE.EMAIL_ADDRESS)
    .max(150, VALIDATION_MESSAGE.MaxLength('Email', 150))
    .trim(),

  phone_number: yup
    .string()
    .optional()
    .test('phone-optional-valid', VALIDATION_MESSAGE.VALID_PHONE, phoneDigitsTest),

  password: yup
    .string()
    .required(VALIDATION_MESSAGE.Field('password'))
    .min(8, VALIDATION_MESSAGE?.MinLength('Password', 8))
    .max(15, VALIDATION_MESSAGE?.MaxLength('Password', 15))
    .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/,
      VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE,
    ),

  confirm_password: yup
    .string()
    .required(VALIDATION_MESSAGE.Field('confirm password'))
    .min(8, VALIDATION_MESSAGE?.MinLength('Confirm password', 8))
    .max(15, VALIDATION_MESSAGE?.MaxLength('Confirm password', 15))
    .oneOf([yup.ref('password')], VALIDATION_MESSAGE?.PASSWORD_CPWD_NOT_MATCHED),

  agree: yup
    .boolean()
    .required(VALIDATION_MESSAGE?.TERMS)
    .oneOf([true], VALIDATION_MESSAGE?.TERMS),

  phone_country_code: yup.string().required(VALIDATION_MESSAGE.Field('country code')),
});

export default RegisterValidation;
